<template>
	<div v-show="isLogin" id="_topMenu">
		
		<div id="searchBox">
			<div class="mainHeader">VIETV MEDIA ASSETS</div>
			<input type="text" placeholder="search" v-model="searchValue" size="100" @keyup.enter="search">
			<div style="display:inline-block">
				<button @click="displayFavorites=!displayFavorites" id="favBtn">@</button>
				<div v-show="displayFavorites" id="favorites">
					<li v-for="item in searchFavorites" @click="searchValue=item;displayFavorites=false">{{item}}</li>
				</div>
			</div>
			<button @click="search">Search</button>
			<button @click="toggleFilter">Filter</button>
		</div>
	
		<button v-if="isLogin" id="loginBtn" @click="logout">Logout</button>
		<router-link to="/setting"><button v-show="true" id="settingBtn">Setting</button></router-link>
		<button id="statusBtn" @click="toggleStatus">Status</button>
		
		<searchFilter v-show="showFilter" @toggleFilter="toggleFilter" @filterUpdate="searchFilters=$event"></searchFilter>
		<STATUS v-show="showStatus" :statusInfo="statusInfo" @toggleStatus="toggleStatus"></STATUS>
		

	</div>
	

	
</template>

<script>

export default {
  name: 'topMenu',
  data () {
    return {
      count: 0,
	  searchValue: '',
	  showFilter: false,
	  showSetting: false,
	  showStatus: false,
	  searchFilters: [],
	  searchFavorites: ["@recent","@occurs"],
	  displayFavorites: false,
	  statusInfo: [],
	  isLogin: this.$bus.login
    }
  },
  methods: {
    search: function () {
		if (this.$route.name!=="HOME") this.$router.push("/home")
		setTimeout(()=>{
			this.$bus.$emit('searchChanged',{search: this.searchValue,filters: this.searchFilters})
		},100)
    },
	logout: function (){
		localStorage.removeItem("token")
		localStorage.removeItem("user")
		this.$bus.login = false
		this.isLogin = false
		this.$router.push("/")
	},
	toggleFilter: function (){
		this.showFilter = !this.showFilter
	},
	toggleSetting: function (){
		this.showStatus = false
		this.showSetting = !this.showSetting
	},
	toggleStatus: function (){
		this.showSetting = false
		this.showStatus = !this.showStatus
		if (this.showStatus) this.updateStatus()
	},
	updateStatus: function (){
		//get new status..
		this.axios.post(this.$bus.mamServer+"/status").then((result)=>{
			this.statusInfo = result.data
			var currentTime = getTime()
			this.statusInfo.forEach(location=>{
				//console.log(currentTime+"::"+location.lastBeat)
				var diff = (Number(currentTime.replace(/:/g,""))-Number(location.lastBeat.replace(/:/g,"")))
				if (diff>500) location.status = "OFFLINE"
			})
		}).catch((err)=>{
			console.log(err)
		})
	}
  },
  created(){
	this.$bus.$on("loggedin",()=>{
		console.log("logged in")
		this.isLogin = true
	})
  }
}

function getTime(){
	var date = new Date()
	var time = ('0'+date.getHours()).slice(-2)+":"+('0'+date.getMinutes()).slice(-2)+":"+('0'+date.getSeconds()).slice(-2)
	return time
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#_topMenu{
	position:fixed;
	top:0;
	width:100%;
	height:35px;
	background-color:#496799;
}

#searchBox{
	float:left;
	margin:5px;
}

#loginBtn{
	float: right;
	margin:5px;
}

#settingBtn{
	float: right;
	margin:5px;
}
	
#statusBtn{
	float: right;
	margin:5px;
}
#favBtn{
	margin-left:-35px
}
#favorites{
	position:fixed;
	top:35px;
	width:120px;
	border-radius:5px;
	border: 1px solid black;
	z-index:100;
	margin-left:-35px;
}

li {
	background-color:lightgray;
	padding: 4px 6px;
    cursor: pointer;
    list-style-type: none;
    transition: all .3s ease;
	margin:1px;
	border-radius: 2px;
	text-align:left;
}

li:hover{
	background-color:lightgreen;
}

.mainHeader{
	float:left;
	font-size:24px;
	color:white;
	margin-right:5px;

}
input {
	height:22px;
	border-radius:5px;
	font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue